import BigNumber from 'bignumber.js';

export const zero = new BigNumber(0);
